import { defineRecipe } from "@chakra-ui/react";

const separatorRecipe = defineRecipe({
  base: {
    my: "blockMargin",
    color: "gray.50",
  },
});

export default separatorRecipe;
